import Axios from "../../src/helpers/axios";

export const getAllProductBrands = (queries) => {
  let url = queries 
    ? `/api/ecommerce/v1/brands/products/all?${queries}`
    : `/api/ecommerce/v1/brands/products/all`
  return Axios.get(url);
};
